import React from "react";
import { SingleDatePicker, DayPicker } from "react-dates";
import { Popup } from "lib/components/vendor";
import Input from "./Input";

export default class DateControl extends React.PureComponent {
  state = {
    focused: false,
  };

  render() {
    const {
      name,
      onChange,
      value,
      readOnly,
      disabled,
      min,
      max,
      isOutsideRange,
      initialValue = value || min,
      className,
      inputClassName,
      isDayHighlighted,
      keepOpenOnDateSelect = false,
      ...rest
    } = this.props;
    const { focused } = this.state;

    const _isOutsideRange =
      isOutsideRange ||
      function (date) {
        if (min && moment(date).isBefore(min)) {
          return true;
        }
        if (max && moment(date).isAfter(max)) {
          return true;
        }
        return false;
      };

    const initialVisibleMonth = () => {
      return moment.parseZone(initialValue);
    };

    const DateInput = (
      <Input
        placeholder={"____ - __ - __"}
        {...rest}
        value={value}
        disabled={disabled}
        readOnly={true}
        className={"u-dateWidth u-DateControl" + (className || "")}
        inputClassName={(focused ? "active" : "") + (inputClassName || "")}
      />
    );

    if (readOnly || disabled) {
      return DateInput;
    }

    return (
      <Popup
        trigger={DateInput}
        on="click"
        open={focused}
        style={{ height: "333px" }}
        onOpen={() => this.setState({ focused: true })}
        onClose={() => this.setState({ focused: false })}
        className="u-paddingHorizontalNone u-paddingBottomNone"
      >
        <DayPicker
          numberOfMonths={1}
          initialVisibleMonth={initialVisibleMonth}
          onDayClick={(date) => {
            onChange(date && !_isOutsideRange(date) ? date.format(moment.RUBY_DATE_FORMAT) : null);
            !keepOpenOnDateSelect && this.setState({ focused: false });
          }}
          modifiers={{
            past: (day) => day.isBefore(),
            today: (day) => day.isSame(undefined, "days"),
            "blocked-out-of-range": _isOutsideRange,
            selected: isDayHighlighted || ((day) => value === day.format(moment.RUBY_DATE_FORMAT)),
          }}
        />
      </Popup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/Date.jsx